
const PS_INITIAL = 'initial'
const PS_SHOW_LOGIN = 'show_login'
//const PS_LOGGEDIN       = 'loggedin'
const PS_TEAM_CAL = 'teamCal'
const PS_TEMPLATE = 'template'
const PS_BOOKING = 'booking'
const PS_REPORT  = 'report';
const PS_APPOINTMENT = 'appointment';
const PS_SETTINGS_SITES = 'settings_sites';

const AppActions = {
    newState: 'newState',
    LOGGED_IN: 'logged_in',
    LOGGED_OUT: 'logged_out'
}

/**
 * This is the core state logic for the App component. It is used by useReducer 
 * inside the component. Most interactions occur through the state and 
 * eventDispatch functions. the state both defines which components get used
 * e.g the team calendar or template calendar as well as variables used by those 
 * components, such as the template calendar and the left menu which share the
 * templateID.
 *
 * @param {any} state the current state
 * @param {any} action the action being performed
 * @returns {object} the new state
 */
const StateReducer = (state, action) => {

    let nextState = { ...state }

    if (action.newState) {
        nextState.pageState = action.newState
    } else {

        switch (state.pageState) {

            case PS_SHOW_LOGIN:

                if (AppActions.LOGGED_IN === action) {
                    nextState.pageState = PS_TEAM_CAL
                }
                break;

            case PS_INITIAL:
                break;

            default:
                if (action.template) {

                    const newTemplateRecord = { ...state.template, ...action.template }
                    nextState.template = newTemplateRecord
                    /* as with app types, don't swich if we have just loaded the 
                     * templates*/
                    if (!action.template.templates) {
                        nextState.pageState = PS_TEMPLATE
                    }
                }

                if (action.team) {
                    // action.team values override state.team
                    const newTeamRecord = { ...state.team, ...action.team }
                    nextState.team = newTeamRecord
                    if (action.team.teamID) {
                        nextState.pageState = PS_TEAM_CAL
                    }
                    nextState.editTeam = action.team.editTeam
                    nextState.applyTemplate = action.team.applyTemplate
                }

                if (action.appType) {

                    const newAppTypeRecord = { ...state.appType, ...action.appType }

                    nextState.appType = newAppTypeRecord
                    /* if we are just loading the app types then don't switch 
                     * to a different menu */
                    if (action.appType.appointmentTypeID || action.appType.overlay) {
                        nextState.pageState = PS_APPOINTMENT
                    }
                }

                if (action.booking) {

                    if (action.clear) {
                        nextState.booking = {}
                        nextState.pageState = PS_TEAM_CAL
                    } else {
                        const newBookingRecord = { ...state.booking, ...action.booking }
                        nextState.booking = newBookingRecord;
                        if (action.appType) {
                            // if we are switching to app calendar and setting booking clinician then 
                            // we need to go to the app type calendar
                            nextState.pageState = PS_APPOINTMENT;
                        }else{
                            nextState.pageState = PS_BOOKING;
                        }
                    }
                }

                if (action.menu) {
                    switch (action.menu) {
                        case 'template':
                            nextState.pageState = PS_TEMPLATE
                            break
                        case 'diary':
                            nextState.pageState = PS_TEAM_CAL
                            break
                        case 'appointment':
                            nextState.pageState = PS_APPOINTMENT
                            break
                        case 'booking':
                            nextState.pageState = PS_BOOKING
                            break;
                        case PS_REPORT:
                            nextState.pageState = action.menu;
                            break;
                        case 'settings':
                            nextState.pageState = PS_SETTINGS_SITES;
                            break;
                        default:

                    }
                }
        }
    }
    return nextState
}


export {
    AppActions, PS_SETTINGS_SITES, PS_APPOINTMENT, PS_INITIAL,
    PS_SHOW_LOGIN, PS_BOOKING, PS_TEAM_CAL, PS_TEMPLATE, PS_REPORT
};
export default StateReducer;